module.exports = __webpack_public_path__ + "assets/img/img-13.da3e434e.png";